import React from 'react';
import styled from 'styled-components';

const GuestAccess = styled.svg`
	width: 56px;
	height: 56px;
	position: relative;
	overflow: visible;
	.cls-1 {
		fill: #a2a9ad;
	}
	.cls-2 {
		fill: ${props => props.theme.Cool_Gray_Light_3};
	}
	text {
		font-size: 25px;
		letter-spacing: 0.9px;
	}
	&.medium {
		width: 80px;
		height: 80px;
		text {
			font-size: 28px;
			letter-spacing: 0.9px;
		}
	}
	&.large {
		width: 136px;
		height: 136px;
		text {
			font-size: 32px;
			letter-spacing: 1.6px;
		}
	}
`;
function getTextPosition(breakpoint) {
	if (breakpoint === 'sm') {
		return { x: 25, y: 140 };
	}
	if (breakpoint === 'md') {
		return { x: 20, y: 140 };
	} else {
		return { x: 5, y: 140 };
	}
}

export const GuestAccessSVG = ({ className, id, breakpoint }) => {
	const { x, y } = getTextPosition(breakpoint);
	return (
		<GuestAccess
			xmlns='http://www.w3.org/2000/svg'
			width='126'
			height='128.023'
			viewBox='0 0 136 128.023'
			id={id}
			className={className}
		>
			<defs>
				<linearGradient
					id={`${id}-guest-access-swipe`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(45)'
				>
					<stop offset='0' stop-color='#8060a9'>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#a2a9ad'>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
				<linearGradient
					id={`${id}-swipe`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(45)'
				>
					<stop offset='0' stop-color='white'>
						<animate
							id={`${id}trans2`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#8060a9'>
						<animate
							id={`${id}trans2`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
			</defs>
			<g id='Layer_1:_badge-icon-select_136_px_' transform='translate(-16.187 -.43)'>
				<g id='Badge' transform='translate(12.187 .43)'>
					<path
						id='badge-2'
						d='M142.78 37.029h-41.309v5.02h2.629a3.44 3.44 0 0 1 0 6.879H70.7a3.44 3.44 0 0 1 0-6.879h2.633v-5.02H32.02A12.772 12.772 0 0 0 19.4 49.952v56.892a12.772 12.772 0 0 0 12.62 12.923h110.76a12.774 12.774 0 0 0 12.62-12.923V49.952a12.774 12.774 0 0 0-12.62-12.923zM82.589 78.4H122.9a2.325 2.325 0 0 1 0 4.649H82.589a2.325 2.325 0 0 1 0-4.649zm-2.271-9.02a2.3 2.3 0 0 1 2.271-2.323h29.233a2.324 2.324 0 0 1 0 4.647H82.589a2.3 2.3 0 0 1-2.271-2.324zM51.72 55.786a10.531 10.531 0 0 1 10.4 10.654c0 5.884-4.658 17.239-10.4 17.239s-10.4-11.355-10.4-17.239a10.531 10.531 0 0 1 10.4-10.654zM75.171 106.4h-46.9V92.868a4.962 4.962 0 0 1 2.516-4.339l6.638-3.709 1.364-.73.007-.036 1.729-.965 3.787-2.428a16.647 16.647 0 0 0 6.436 5.664 17.354 17.354 0 0 1 1.947 0 16.625 16.625 0 0 0 6.436-5.664l3.787 2.426 9.74 5.443a4.967 4.967 0 0 1 2.516 4.339zm37.74-.671H82.589a2.325 2.325 0 0 1 0-4.649h30.322a2.325 2.325 0 0 1 0 4.649zm30.322-11.341H82.589a2.325 2.325 0 0 1 0-4.649h60.644a2.325 2.325 0 0 1 0 4.649zm0-34.026H82.589a2.325 2.325 0 0 1 0-4.649h60.644a2.325 2.325 0 0 1 0 4.649z'
						class='cls-1'
						transform='translate(-15.4 -13.369)'
					/>
					<path
						id='strap'
						d='M66.8 26.611H46.614a2.142 2.142 0 0 0-2.114 2.167v27.767a2.144 2.144 0 0 0 2.117 2.169H66.8a2.144 2.144 0 0 0 2.117-2.169V28.778a2.142 2.142 0 0 0-2.117-2.167zm-10.093 10.02a3.434 3.434 0 1 1 3.355-3.431 3.4 3.4 0 0 1-3.355 3.431z'
						class='cls-1'
						transform='translate(15.293 -26.611)'
					/>
				</g>
				<text class='cls-1 buttons51' x={x} y={y}>
					GUEST ACCESS
				</text>
			</g>
		</GuestAccess>
	);
};
